import React, { Component } from 'react';
import { Modal, Input, Spin, message } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';

class InformRequest extends Component {
    state = {
        record: {},
        saveParams: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        });
    }

    hide = () => {
        this.setState({
            saveParams: {},
            visible: false,
        });
    }

    handleInputChange = (e, key) => {
        const { saveParams } = this.state;
        saveParams[key] = e.target.value;
        this.setState({ saveParams });
    }

    submit = () => {
        const {
            record,
            saveParams,
        } = this.state;
        const { contractRemittanceApplicationId } = record;

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.noticeBdCashReq,
            data: {
                contractRemittanceApplicationId,
                ...saveParams,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getContent = () => {
        const { record, saveParams } = this.state;
        const {
            investigationName,
            investigationJdeContractCode,
            remittanceNum,
            cashReqNode,
            remittanceAmount,
        } = record;
        const { remark } = saveParams;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">项目简称:</div>
                    <div className="item-right">
                        {investigationName}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">JDE项目号:</div>
                    <div className="item-right">
                        {investigationJdeContractCode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">请款笔数:</div>
                    <div className="item-right">
                        {remittanceNum}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">请款节点:</div>
                    <div className="item-right">
                        {cashReqNode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">合同约定请款金额/人民币:</div>
                    <div className="item-right">
                        {format('money', remittanceAmount)} 元
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">备注:</div>
                    <div className="item-right">
                        <Input
                            placeholder="请输入"
                            style={{ width: 182 }}
                            value={remark}
                            onChange={e => this.handleInputChange(e, 'remark')}
                        />
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="通知请款"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                confirmLoading={loading}
                maskClosable={false}
                width="520px"
            >
                 <Spin spinning={loading}>
                    <div style={{ margin: '0 auto', paddingLeft: 20, width: 400, lineHeight: '28px', background: '#f1f1f1' }}>确认此项目已达到所要求的请款节点，确认后将会通知CSA发起请款</div>
                    <div className="modal-content heredity" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default InformRequest;


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/InformRequest.js